// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__l1oGL","modal__inner":"modal_modal__inner__zuc8D","modal__heading":"modal_modal__heading__qUQoS"};